/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import React, { Fragment } from 'react';

import {
    LinkList,
    LinkListVariant,
} from '@toucan/client/blocks/components/link-list';

import { DesktopLinksProps } from './types';

export const DesktopLinks = ({ links, ...otherProps }: DesktopLinksProps) => {
    return (
        <Fragment>
            {links.map((link) => {
                return (
                    <div key={link.title} {...otherProps}>
                        <Heading
                            data-id="footer__desktop-links__heading"
                            size={HeadingSize.H4}
                        >
                            {link.title}
                        </Heading>
                        <LinkList
                            data-id="footer__desktop-links__link-list"
                            links={link.links}
                            variant={LinkListVariant.BLOCK}
                        />
                    </div>
                );
            })}
        </Fragment>
    );
};
